import React from 'react';
import { tEnum } from "../../../config/translations";




const ApplicationStatusProgress = ({ data = [] }) => {
    const total = data.reduce((sum, item) => sum + item.value, 0);

    const COLORS = {
        APPROVED: getCss("--valtekGreen", "#367221"),
        REVIEWING: getCss("--valtekInfo", "#60a5fa"),
        NEW: getCss("--valtekWarning", "#facc15"),
        REJECTED: getCss("--valtekRed", "#8b0000"),
        WITHDRAWN: getCss("--valtekPrimary", "#a855f7"),
    };

    return (
        <div className="card">
            <h3 className="card-title">Başvuru Durumları</h3>

            <div className="progress-list">

                {data.map((item) => {
                    const percent = total ? Math.round((item.value / total) * 100) : 0;
                    const translated = tEnum("STATUS", item.name?.toUpperCase());

                    return (
                        <div key={item.name} className="progress-row mt-4">

                            <div className="progress-header">
                                <span>{translated}</span>
                                <span>{item.value}</span>
                            </div>

                            <div className="progress-track">
                                <div
                                    className="progress-fill"
                                    style={{
                                        width: `${percent}%`,
                                        background: COLORS[item.name?.toUpperCase()],
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};


export default ApplicationStatusProgress;

function getCss(name, fallback) {
    if (typeof window === "undefined") return fallback;
    return getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .trim() || fallback;
}
